import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import {isNullOrUndefined} from 'util';

@Injectable({
  providedIn: 'root'
})
export class RcTranslateService {

    private textTranslation: any;

    constructor() {

    }

    /**
     * Set resource object
     * @param obj
     */
    setTranslation(obj: any) {
      this.textTranslation = obj;
    }

    /**
     * Get resource value
     * @param key
     * @param placeholdersReplace
     * @returns string
     */
    getText(key: string, placeholdersReplace: any = []): string {
        if (isNullOrUndefined(key)) {
            return '';
        }

        const value = _.at(this.textTranslation, key);

        if (value.length > 0) {
            if (placeholdersReplace.length) {
            }
            if (placeholdersReplace && Array.isArray(placeholdersReplace) && placeholdersReplace.length > 0) {
                value[0] = this.replacePlaceholders(value[0], placeholdersReplace);
            }
            return value[0];
        }
        return key;
    }

    /**
     * @param text
     * @param placeholders
     * @returns string
     */
    private replacePlaceholders(text: string, placeholders: any[]): string {
        if (isNullOrUndefined(text)) {
            return '';
        }

        let counter = 0;

        placeholders.forEach((placeholder) => {
            if (!isNullOrUndefined(placeholder)){
                placeholder = placeholder.toString();
                text = text.replace(`{${counter}}`, placeholder);
            }
            counter++;
        });
        return text;
    }

    /**
     * Merge 2 objects recursive
     * @param target
     * @param source
     * @returns Object
     */
    mergeDeep (target: any, source: any): any {
        if (typeof(target) === 'object' && typeof(source) === 'object') {
            for (let key in source) {
                if (typeof(source[key]) === 'object') {
                    if (!target[key]) {
                        Object.assign(target, { [key]: {} });
                    }
                    this.mergeDeep(target[key], source[key]);
                } else {
                    Object.assign(target, { [key]: source[key] });
                }
            }
        }
        return target;
    }
}



